import { render, staticRenderFns } from "./ReleaseLink.vue?vue&type=template&id=f2eace5e&"
import script from "./ReleaseLink.vue?vue&type=script&lang=js&"
export * from "./ReleaseLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports